<template>
    <div class="booking__basket" v-if="dictionary != null">
        <p class="booking__headline">{{ dictionary.BookingFlowBasketHeadline }} <span v-if="!basketIsEmpty">({{
            basket.length
        }})</span></p>
        <p class="booking__message" v-if="basketIsEmpty">{{ dictionary.BookingFlowBasketMessage }}</p>
        <div v-if="!basketIsEmpty">
            <ul class="basket__list">
                <li class="basket-item" v-for="entry in basket" :key="entry.room.Id">
                    <div class="basket-item__header">
                        <p class="basket-item__size">{{ dictionary.BookingFlowCommonSize }}: {{ entry.room.Size }}
                            m<sup>2</sup></p>
                        <Button class="p-button-text p-button-danger" icon="pi pi-trash"
                            @click="removeRoom(entry.room.Size)"></Button>
                    </div>
                    <div class="basket-item__info">
                        <p class="basket-item__address">{{ department.City }}, {{ department.Address }} {{
                            department.Address2
                        }}</p>
                        <p class="basket-item__room-number">{{ dictionary.BookingFlowCommonRoomNumber }}: {{
                            entry.room.Number
                        }}
                            <span class="basket-item__room-number-change" v-if="entry.otherRooms.length > 1">
                                <Button class="p-button-text" :data-panel-ref="'room' + entry.room.Id"
                                    :aria-label="dictionary.BookingFlowBasketRoomPickerLabel + ' ' + entry.room.Size + 'm2'"
                                    icon="pi pi-sync" @click="toggleBasketDialog"></Button>
                                <OverlayPanel :ref="'room' + entry.room.Id" :showCloseIcon="true" :dismissable="true">
                                    <Dropdown aria-labelledby="roomDropdownLabel" v-model="entry.room"
                                        :options="entry.otherRooms.filter(x => !basket.some(y=> y.room.Id == x.Id))" @change="handleRoomChange">
                                        <template #value="slotProps">
                                            <div>
                                                {{ slotProps.value.Number }}
                                            </div>
                                        </template>
                                        <template #option="slotProps">
                                            <div>
                                                {{ slotProps.option.Number }}
                                            </div>
                                        </template>
                                    </Dropdown>
                                </OverlayPanel>
                            </span>
                        </p>
                        <p class="basket-item__size">{{ dictionary.BookingFlowCommonSize }}: {{ entry.room.Size }}
                            m<sup>2</sup></p>
                        <p>{{ dictionary.BookingFlowCommonPortNumber }}: {{ entry.room.GateNumber }}</p>
                    </div>

                    <div class="basket-item__padlock">
                        <InputSwitch v-model="entry.padlock" @change="togglePadlock"></InputSwitch>
                        <span v-if="entry.padlock">{{
                            dictionary.BookingFlowBasketPadlockTrue.replace('{price}',
                               getFormattedNumberString(entry['priceCalculation']?.PadlockPrice,0))
                        }}</span>
                        <span v-if="!entry.padlock">{{ dictionary.BookingFlowBasketPadlockFalse }}</span>
                    </div>

                    <div class="basket-item__price-wrap">
                        <div class="basket__price" :class="{'basket__campaign':priceLine.IsHighlighted}" v-for="(priceLine,index) in entry['priceCalculation']?.Lines" :key="index">

                            <div>
                                {{ priceLine.Text }}
                            <small class="basket__price--extra" v-if="priceLine.Subtext">{{ priceLine.Subtext }}</small>

                            </div>
                            <div>
                                {{
                                    getFormattedNumberString(priceLine.Price)
                                }}{{ priceSuffix }}
                            </div>
                        </div>
                    </div>

                    <div class="field basket-item__discount-wrap">
                        <button v-if="step != steps.confirm && entry.discountCode == null" type="button"
                            class="booking__text-button" @click="toggleBasketDialog"
                            :data-panel-ref="'discount' + entry.room.Id">
                            {{ dictionary.BookingFlowBasketDiscountCodeLabel }}</button>
                        <OverlayPanel :ref="'discount' + entry.room.Id" :showCloseIcon="true" :dismissable="true">
                            <div class="p-inputgroup">
                                <InputText id="discountCodeInput" type="text" v-model="discountCodeInput"
                                    placeholder="Indtast rabatkode" />
                                <Button icon="pi pi-plus" class="p-button-secondary"
                                    @click="addDiscountCode(entry.room.Id)"></Button>
                            </div>
                        </OverlayPanel>
                        <p class="basket__code" v-if="entry.discountCode != null">{{
                            dictionary.BookingFlowBasketDiscountCode
                        }}: <b>{{ entry.discountCode }}</b> <Button v-if="step != steps.confirm"
                                class="p-button-text p-button-danger" icon="pi pi-times"
                                @click="removeDiscountCode(entry.room.Id)"></Button></p>
                    </div>
                </li>
            </ul>
            <div class="basket-sum">
                <p class="booking__headline">{{ dictionary.BookingFlowBasketPaymentTitle }}</p>
                 <div class="basket__price" :class="{'basket__campaign':summaryLine.IsHighlighted,'basket__price--hidden':(((index +1) > basketSummary.NumberOfLinesToShow) && !showAllSummaryLines)}" v-for="(summaryLine,index) in basketSummary?.Lines" :key="index">

                            <div>
                                {{ summaryLine.Text }}
                            <small class="basket__price--extra" v-if="summaryLine.Subtext">{{ summaryLine.Subtext }}</small>

                            </div>
                            <div>
                                {{
                                    getFormattedNumberString(summaryLine.Price)
                                }}{{ priceSuffix }}
                            </div>
                        </div>
                           <button v-if="basketSummary?.Lines.length > basketSummary?.NumberOfLinesToShow" @click="showAllSummaryLines = !showAllSummaryLines" class="booking__text-button">
                <span v-if="!showAllSummaryLines">{{ dictionary.BookingFlowBasketShowAllSummaryLines }}</span>
                <span v-else>{{ dictionary.BookingFlowBasketShowDefaultSummaryLines }}</span>
            </button>
            </div>
         
            <p class="basket__binding-period">{{ dictionary.BookingFlowBasketNoBindingPeriodText }}</p>
        </div>

        <Button v-if="(typeof nextStepButtonText !== 'undefined')" class="p-button-rounded basket__button"
            :disabled="typeof nextStepDisableOverride !== 'undefined' ? nextStepDisableOverride : basketIsEmpty" @click="handleStepChange" :label="nextStepButtonText"></Button>
        <div v-if="!basketIsEmpty" class="basket__invitation">
            <button :disabled="invitationCode != null" type="button" class="booking__text-button"
                @click="toggleBasketDialog" data-panel-ref="basketInvitationCodeOverlay">
                {{ dictionary.BookingFlowBasketInvitationCodeLabel }}</button>
            <OverlayPanel :ref="'basketInvitationCodeOverlay'" :showCloseIcon="true" :dismissable="true">
                <div class="p-inputgroup">
                    <InputText id="invitationCodeInput" type="text" v-model="invitationCodeInput"
                        placeholder="Indtast invitationskode" />
                    <Button icon="pi pi-plus" class="p-button-secondary"
                        @click="handleInvitationCodeChange(false)"></Button>
                </div>

            </OverlayPanel>
            <p class="basket__code" v-if="invitationCode != null">{{ dictionary.BookingFlowBasketInvitationCode }}: {{
                invitationCode
            }} <Button class="p-button-text p-button-danger" icon="pi pi-times"
                    @click="handleInvitationCodeChange(true)"></Button></p>
        </div>
    </div>
</template>
<script>
import Button from "primevue/button";
import InputText from "primevue/inputtext";
import Dropdown from 'primevue/dropdown';
import InputSwitch from 'primevue/inputswitch';
import OverlayPanel from 'primevue/overlaypanel';
import ConfirmDialog from 'primevue/confirmdialog';

export default {
    name: "bookingBasket",
    components: {
        Button,
        InputText,
        Dropdown,
        InputSwitch,
        OverlayPanel,
        ConfirmDialog
    },
    props: ["department", "basket","basketSummary","padlockPrice", "invitationCode", "nextStep", "nextStepButtonText", "ignoreInheritedStepChangeHandler", "step", "steps","nextStepDisableOverride"],
    data() {
        return {
            dictionary: null,
            invitationCodeInput: null,
            discountCodeInput: null,
            lastAccessedPanelRef: null,
            priceSuffix: " ,-",
            showAllSummaryLines:false
        };
    },
    created() {
        const vm = this;
        fetch("/umbraco/api/dictionaryapi/GetBasketDictionary").then((response) => response.json())
            .then((data) => {
                vm.dictionary = data;
                vm.priceSuffix = data.BookingFlowBasketPriceSuffix;
            })
            .catch((error) => {
                console.log(error);
            });
    },
    methods: {
        getFormattedNumberString(value,fractionDigits = 2) {
            if (typeof value == 'undefined') return value;

            return (value / 100).toLocaleString('da-DK', {
                minimumFractionDigits: fractionDigits,
                maximumFractionDigits: fractionDigits
            });
        },
        toggleBasketDialog(event) {
            const panelRef = event.target.dataset.panelRef;
            this.lastAccessedPanelRef = panelRef;
            if (this.$refs[panelRef].length) {
                this.$refs[panelRef][0].toggle(event);
            } else {
                this.$refs[panelRef].toggle(event);
            }
        },
        handleRoomChange(e) {
            this.$emit("roomChanged", e.value.Id);
        },
        handleStepChange() {
            const vm = this;
            if (vm.step == vm.steps.rooms && vm.basket.length > 1) {
                vm.$confirm.require({
                    message: vm.dictionary.BookingFlowBasketMultipleRoomsDialogText,
                    header: vm.dictionary.BookingFlowBasketMultipleRoomsDialogTitle,
                    acceptLabel: vm.dictionary.BookingFlowBasketMultipleRoomsDialogAcceptButtonText,
                    rejectLabel: vm.dictionary.BookingFlowBasketMultipleRoomsDialogDeclineButtonText,
                    acceptClass: "p-button-secondary p-button-rounded",
                    rejectClass: "p-button-secondary p-button-rounded",
                    accept: () => {
                        vm.changeStep();
                    },
                    reject: () => {
                        return false;
                    }
                })
            } else {
                vm.changeStep();
            }

        },
        changeStep() {
            const vm = this;
            if (typeof vm.ignoreInheritedStepChangeHandler !== "undefined" && vm.ignoreInheritedStepChangeHandler) {
                vm.$emit("stepChangeOverridden", vm.nextStep)
            } else {
                vm.$emit("stepChange", vm.nextStep);
            }
        },
        removeRoom(roomSize) {
            this.$emit("removeRoom", roomSize);
        },
        handleInvitationCodeChange(remove = false) {
            this.$refs[this.lastAccessedPanelRef].hide();
            this.$emit("invitationCodeChange", this.invitationCodeInput, remove)
            this.invitationCodeInput = null;
        },
        addDiscountCode(roomId) {
            this.$refs[this.lastAccessedPanelRef][0].hide();
            this.$emit("addDiscountCode", this.discountCodeInput, roomId);
            this.discountCodeInput = null;
        },
        removeDiscountCode(roomId) {
            this.$emit("removeDiscountCode", roomId);
        },
        togglePadlock(){
            this.$emit("togglePadlock");
        }
    },
    computed: {
        basketIsEmpty() {
            return this.basket.length == 0;
        }
    },
};
</script>
